import { STMarkerStyleDmlC } from '../../../../../Interface/chart-v3/sdk-model.interface';
import type {
    IMarkerProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/geometry/marker/marker.interface';
import type {
    IChartMarker,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import { ISeriesProperty } from '../../series/series.interface';
import { IDataItemProperty } from '../../data-item/data-item.interface';
import { NullableDeep } from '../../../chart-shape-property.interface';
import ChartShapeProperty from '../../../chart-shape-property';

export class MarkerProperty extends ChartShapeProperty<IChartMarker> implements IMarkerProperty {
    public symbol: STMarkerStyleDmlC;
    private parentProperty: ISeriesProperty | IDataItemProperty;

    public init(parentProperty) {
        this.parentProperty = parentProperty;
        this.setSymbol();

        return this;
    }

    public setSymbol() {
        this.symbol = (this.uiData.symbol as STMarkerStyleDmlC) || STMarkerStyleDmlC.circle;
    }

    public updateProps(
        props: Partial<IChartMarker>,
        removeProps?: Partial<NullableDeep<IChartMarker>>,
    ): void {
        this.parentProperty.updateMarker(props, removeProps);
    }

    /**
     * marker可能为 undefined 或者 { ..., symbol:'none' }
     * */
    public createMarker(symbol: STMarkerStyleDmlC) {
        this.parentProperty.createMarker(symbol);
    }

    public getParentProperty() {
        return this.parentProperty;
    }
}
